import { Component } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { container } from '@/app-modules/_ioc';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';
import { IPersistedStore } from '@/app-modules/store/persisted-store';
import { IEventBusService } from '@/app-modules/event-bus/event-bus-service';
import { UserSettingsUpdatedEventName } from '@/components/user-settings/_domain/models';

@Component({
  name: 'PlayerSearchComponent'
})
export default class PlayerSearchComponent extends TombolaBaseComponent {
  private playerUsername: string = '';

  private searchForPlayer(): void {
    this.savePlayerNotesUsernameToStore(this.playerUsername);
  }

  private savePlayerNotesUsernameToStore(username: string): void {
    const persistedStore = container.get(SERVICE_IDENTIFIERS.IPersistedStore) as IPersistedStore;
    const userPreferences = persistedStore.Get(UserPreferences);
    userPreferences.playerNotesUsername = username.trim();
    persistedStore.Save(userPreferences);
    this.emitUserSettingsUpdatedEvent();
  }

  private emitUserSettingsUpdatedEvent(): void {
    this.eventBusService.getEventBus().$emit(UserSettingsUpdatedEventName);
  }

  private get eventBusService(): IEventBusService {
    return this.$container.get(SERVICE_IDENTIFIERS.IEventBusService);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/player-notes/_components/player-search/player-search.component.ts